import { API } from "../../http-common";
import millify from "millify";

export default {
  state: {
    badge: {
      cod: {
        COD_FOR_CONFIRMATION: "0",
        COD_FOR_INSTALLATION: "0",
        COD_PAST_DUE: "0",
        COD_INSTALLED: "0",
        COD_CANCELLED: "0",
      },
    },
  },

  mutations: {
    SET_COD_BADGE(state, payload) {
      const { type, param, value } = payload;
      state.badge[type][param] = value;
    },
  },

  actions: {
    ADD_COD_BADGE: async ({ commit }) => {
      const COD_CANCELLED = await API.post(`/acquisition/count`, {
        status: "COD_CANCELLED",
      }).then((response) => {
        const res = response.data;
        const newArr = res.data.count;
        return newArr;
      });
      commit("SET_COD_BADGE", {
        type: "cod",
        param: "COD_CANCELLED",
        value: millify(COD_CANCELLED),
      });

      const COD_PENDING = await API.post(`/acquisition/count`, {
        status: "COD_PENDING",
      }).then((response) => {
        const res = response.data;
        const newArr = res.data.count;
        return newArr;
      });
      commit("SET_COD_BADGE", {
        type: "cod",
        param: "COD_FOR_CONFIRMATION",
        value: millify(COD_PENDING),
      });


      const COD_FOR_INSTALLATION = await API.post(`/acquisition/count`, {
        status: "PAID",
      }).then((response) => {
        const res = response.data;
        const newArr = res.data.count;
        return newArr;
      });
      commit("SET_COD_BADGE", {
        type: "cod",
        param: "COD_FOR_INSTALLATION",
        value: millify(COD_FOR_INSTALLATION),
      });


      const COD_PAST_DUE = await API.post(`/acquisition/count`, {
        status: "COD_PAST_DUE",
      }).then((response) => {
        const res = response.data;
        const newArr = res.data.count;
        return newArr;
      });
      commit("SET_COD_BADGE", {
        type: "cod",
        param: "COD_PAST_DUE",
        value: millify(COD_PAST_DUE),
      });

      const COD_INSTALLED = await API.post(`/acquisition/count`, {
        status: "ACTIVATED",
      }).then((response) => {
        const res = response.data;
        const newArr = res.data.count;
        return newArr;
      });
      commit("SET_COD_BADGE", {
        type: "cod",
        param: "COD_INSTALLED",
        value: millify(COD_INSTALLED),
      });
    },
  },

  getters: {
    GET_COD_BADGE: (state) => state.badge,
  },
};
